import { Icon } from "../../toolbar-buttons";
import ToggleButton from "../toggle-button";
import style from "./orgchart-item-view-type.module.css";
import { OrgChartViewType } from "shared/datamodel/schemas/org-chart";

export default function OrgChartItemViewType({
  value,
  onChange,
}: {
  value: OrgChartViewType;
  onChange: (viewtype: OrgChartViewType) => void;
}) {
  return (
    <div className={style.container} data-testid="OrgchartItemViewType">
      <ToggleButton
        isOn={value === OrgChartViewType.Default}
        onClick={() => onChange(OrgChartViewType.Default)}
        tooltip={"Show image"}
      >
        <Icon icon="icon-orgchart-yes-photo" />
      </ToggleButton>
      <ToggleButton
        isOn={value === OrgChartViewType.NoProfilePicture}
        onClick={() => onChange(OrgChartViewType.NoProfilePicture)}
        tooltip={"Hide image"}
      >
        <Icon icon="icon-orgchart-no-photo" />
      </ToggleButton>
    </div>
  );
}
